import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApplicationConfigService } from '../../../core/application-config.service';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {
  resourceUrl: string='';

  constructor(
    protected http:HttpClient,
    private readonly applicationConfigService: ApplicationConfigService
  ) {
    this.resourceUrl = this.applicationConfigService.getEndpointFor();
   }

  changePassword( payload: any): Observable<any> {
      return this.http.put(`${this.resourceUrl}/Users/change-password`, payload);
  }
}
